import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import PrestigeVisionHero from "./sections/PrestigeVisionHero";
import DigitalArsenal from "./sections/DigitalArsenal";
import TheCoastalAdvantage from "./sections/TheCoastalAdvantage";
import MasteryShowcase from "./sections/MasteryShowcase";
import ReadyToScale from "./sections/ReadyToScale";
import ContactUs from "./sections/ContactUs";
import Fahrzeuge from "./sections/Fahrzeuge";
import Comments from "./sections/Comments";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <PrestigeVisionHero />
      <DigitalArsenal />
      <TheCoastalAdvantage />
      <MasteryShowcase />
      <Fahrzeuge />
      <ReadyToScale />
      <Comments />
      <ContactUs />
      <Footer />
    </div>;
}